import Chinese5000WordsPinyin from '../assets/Vocab/Chinese5000WordsPinyin.json';
import EnglishMostFrequentWords from '../assets/Vocab/EnglishMostFrequentWords.json';
import SomaliMostFrequentWords from '../assets/Vocab/SomaliMostFrequentWords.json';
import Chinese1500IdiomsPinyin from '../assets/Vocab/Chinese1500IdiomsPinyin.json';


const COMMON_WORDS = EnglishMostFrequentWords;
const COMMON_SOMALI_WORDS = SomaliMostFrequentWords;
const COMMON_CHINESE_WORDS = Chinese5000WordsPinyin;
const COMMON_CHINESE_IDIOMS_WORDS = Chinese1500IdiomsPinyin;
const COMMON_SOMALI_IDIOMS_WORDS = SomaliMostFrequentWords;


export {
    COMMON_WORDS,
    COMMON_SOMALI_WORDS,
    COMMON_CHINESE_WORDS,
    COMMON_CHINESE_IDIOMS_WORDS,
    COMMON_SOMALI_IDIOMS_WORDS
}